import { HiMoon, HiSun } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { useThemeStore } from '../store/themeStore';

/**
 * El interruptor de claro y oscuro, en un solo sitio.
 *
 * Estaba escrito a mano en `DashboardLayout` y en `AuthLayout`, y hacía falta
 * un tercero en los documentos legales. Tres copias del mismo botón es cuando
 * empiezan a separarse, y ya lo habían hecho: el del panel llevaba
 * `title={isDark ? 'Light mode' : 'Dark mode'}` **escrito en inglés dentro del
 * JSX**, que es exactamente lo que prohíbe la regla de oro del proyecto; el de
 * las pantallas de acceso no llevaba nombre de ninguna clase, así que para
 * quien usa un lector de pantalla era un botón sin etiqueta.
 *
 * Dice a dónde va, no dónde está: con el tema claro puesto, el botón ofrece
 * «Modo oscuro», que es lo que pasará si lo pulsas.
 */
export default function BotonTema({ className = '' }) {
    const { isDark, toggleTheme } = useThemeStore();
    const { t } = useTranslation();

    const etiqueta = t(isDark ? 'common.light_mode' : 'common.dark_mode');

    return (
        <button
            type="button"
            onClick={toggleTheme}
            title={etiqueta}
            aria-label={etiqueta}
            className={`p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors ${className}`}
        >
            {isDark
                ? <HiSun className="w-5 h-5 text-yellow-500" />
                : <HiMoon className="w-5 h-5 text-slate-600 dark:text-slate-300" />}
        </button>
    );
}
